var React = require('react');

function SvgFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.382 7.071l.333-2.357h-3V3.38c0-.708.75-1.022 1.75-1.022h.75V.08S7.132 0 6.215 0c-1.917 0-3 1.1-3 3.143v1.571h-2.5v2.357h2.5v5.5h2.5v-5.5h2.667z","fill":"#71706A"}));
}

SvgFacebookInline.defaultProps = {"width":"9","height":"13","fill":"none"};

module.exports = SvgFacebookInline;

SvgFacebookInline.default = SvgFacebookInline;
